import { NotFoundBlock } from '../../components/NotFoundBlock/NotFoundBlock';

export const NotFound = () => {
  return (
    <>
      <NotFoundBlock />
    </>
  );
};
